if (!customElements.get('ms-collection-categories')) {
  customElements.define('ms-collection-categories', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.track = this.querySelector('.ms-collection-categories__track');
      this.controls = this.querySelector('.ms-collection-categories__controls');
      this.previous = this.querySelector('[name="prev"]');
      this.next = this.querySelector('[name="next"]');
      this.update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = maximum <= 1;
        this.previous.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft >= maximum - 1;
      };
      this.onClick = event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        const item = this.track.querySelector('.ms-collection-category');
        const step = item.offsetWidth + parseFloat(getComputedStyle(this.track).columnGap);
        const distance = Math.max(step, Math.floor(this.track.clientWidth / step) * step);
        this.track.scrollBy({
          left: button.name === 'next' ? distance : -distance,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      this.controls.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.controls?.removeEventListener('click', this.onClick);
      this.track?.removeEventListener('scroll', this.update);
    }
  });
}
